<mat-dialog-title fxLayout>
    <div class="font-family-NB" >{{dialogData.header}}</div>
</mat-dialog-title>
<mat-dialog-content class="font-family-NSB mt-2">
    <p>{{dialogData.description}}</p>
</mat-dialog-content>
<mat-dialog-actions fxLayout fxLayout="row" fxLayoutAlign="end">
    <button mat-button class="btn btn-danger radius-50 font-family-NB" [disableRipple]="true" (click)="delete()">{{dialogData.okbutton}}</button>
    <button mat-button class="btn btn-dark radius-50 font-family-NB" [disableRipple]="true" (click)="cancel()">{{dialogData.cancelbutton}}</button>
</mat-dialog-actions>